import React from 'react';

import styles from './Activity.module.less';
import GameLink from '../GameLink';

export default ({ data, tag: source }) => {
  return (
    <GameLink
      className={styles.Activity}
      info={data}
      source={source}
      logInfo={{
        category: 'C',
        action: source,
        params: {
          id: data.activityId || '',
          source,
        },
        bizInfo: data.bizInfo,
      }}
    >
      <div className={'activity_cont'}>
        <img className={'banner_item_bg'} src={data.contentImgBig || data.contentImg} />
        <div>
          <h1 title={data.contentTitle}>{data.contentTitle}</h1>
          <p>{data.contentDesc}</p>
          <h2>
            活动时间：
            <br />
            {data.activityStartTime.replace(/\s*\d+:\d+:\d+/g, '').replace(/-/g, '.')} -{' '}
            {data.activityEndTime.replace(/\s*\d+:\d+:\d+/g, '').replace(/-/g, '.')}
          </h2>
          {data.activityType === '1' ? (
            <span className="waiting">待开始</span>
          ) : data.activityType === '2' ? (
            <span className="active">进行中</span>
          ) : (
            <span className="closed">已结束</span>
          )}
        </div>
      </div>
    </GameLink>
  );
};
